import {client} from "./client";


class adsApi {

    static async findByStreet(input) {
        let result = await client.get('/ads/search', {
            params: {
                street: input
            }
        });

        return result.data;
    }
}

export default adsApi;